export default "__VITE_ASSET__CgQC03Tu__"